module.exports = __webpack_public_path__ + "img/design7.cb0342f6.png";